import React, {useState} from "react";
import {Button, Input, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {useAppContext} from "../../hooks";
import {postJsonAxiosService} from "../../services/callAxios";
import {toastService} from "../../services/toast.service";

const EightByEightModal = (props) => {
    const {user} = useAppContext();
    const {provider, toggle} = props;
    const [apiKey, setApiKey] = useState("");
    const [errorApiKey, setErrorApiKey] = useState(false);
    const [apiSecret, setApiSecret] = useState("");
    const [errorApiSecret, setErrorApiSecret] = useState(false);

    const handleSubmit = async (values) => {
        if (!apiKey) {
            setErrorApiKey(true);
        }
        if (!apiSecret) {
            setErrorApiSecret(true);
        }
        if (!apiKey || !apiSecret) {
            return;
        }
        
        let provider = {
            providerId: "",
            accessToken: apiKey,
            refreshToken: apiSecret,
            provider: "eightByEight",
            service: "Dialer",
        }
        try {
            let response = await postJsonAxiosService("eightByEight/webhook/validate", {provider: provider});

            if (response && response?.status === 200) {
                toastService.info("8x8 Integrated");
                // await new Promise(resolve => setTimeout(resolve, 2000));
                window.location.reload();

            } else {
                toggle();
               toastService.error("Invalid API Key/Secret");
            }
        } catch (e) {
            toastService.error("Error while updating integration");
        }
    };

    return (
        <div style={{padding: 20}}>
            <ModalHeader toggle={props.toggle}
                         style={{fontSize: 24, fontWeight: 600, border: "none"}}>
                <span>Add 8x8 Dialer Integration</span>
            </ModalHeader>
            <ModalBody>
                <div>
                    <div className="snippet-desc" style={{fontSize: 14, color: "#202124"}}>
                        <label>API Key</label>
                        <Input style={{fontSize: 14, color: "#202124"}}
                               placeholder="Enter API Key from 8x8 Admin Console"
                               value={apiKey}
                               onChange={(e) => {
                                   setApiKey(e.target.value);
                                   setErrorApiKey(false);
                               }}
                        />
                        {errorApiKey ? (
                            <div className="snippet-desc-error" style={{color: "red"}}>
                                Please enter API Key from your 8x8 account
                            </div>
                        ) : null}
                        <div style={{fontSize: 12, color: "#666", marginTop: 5}}>
                            You can generate API credentials in your 8x8 Admin Console under API Keys
                        </div>
                        
                        <label style={{paddingTop: 10}}>API Secret</label>
                        <Input 
                            type="password"
                            style={{fontSize: 14, color: "#202124"}}
                            placeholder="Enter API Secret from 8x8 Admin Console"
                            value={apiSecret}
                            onChange={(e) => {
                                setApiSecret(e.target.value);
                                setErrorApiSecret(false);
                            }}
                        />
                        {errorApiSecret ? (
                            <div className="snippet-desc-error" style={{color: "red"}}>
                                Please enter API Secret from your 8x8 account
                            </div>
                        ) : null}
                        <div style={{fontSize: 12, color: "#666", marginTop: 5}}>
                            Generated along with your API Key in the 8x8 Admin Console
                        </div>
                    </div>
                    <div>
                    </div>
                </div>

            </ModalBody>
            <ModalFooter style={{border: "none", padding: "0px 0px 10px 30px"}}>
                <Button className={"btn-typography-secondary"} onClick={props.toggle}>
                    Cancel
                </Button>{" "}
                <Button className={"btn-typography-primary"} onClick={handleSubmit}>
                    Authorize
                </Button>{" "}
            </ModalFooter>
        </div>
    )
};

export default EightByEightModal;

